import publicApi from "@/lib/publicApi";

export const readPublishedWebsite = async signal => (await publicApi.get("/public/website", { signal })).data;
export const listPublishedInventory = async (params, signal) => (await publicApi.get("/public/inventory", { params, signal })).data;
export const holdPublishedPlot = async (id, key) => (await publicApi.post(`/public/inventory/${id}/hold`, { idempotency_key: key })).data;
export const createPublicBooking = async body => (await publicApi.post("/public/bookings", body)).data;
